import dashboard from './system/dashboard'
import general from './menus/general'
import config from './system/config'

// eslint-disable-next-line import/no-mutable-exports
let sections = [
  ...dashboard,
  ...general,
]

const userData = JSON.parse(localStorage.getItem('userData'))

// Verificar el valor de la variable para decidir si agregar el elemento ...config
if (userData != null && userData.role === 'admin') {
  console.log('UserData: ', userData)
  sections = [...sections, ...config]
}

export default sections
